export const useAppStore = defineStore('app', () => {
  const isMainMenuOpened = ref<boolean>(false)
  const isSearchOpened = ref<boolean>(false)
  const isTickerOpened = ref<boolean>(false)
  const debugValue: string = 'debug'
  const inputBuffer = ref<string>('')

  // Enable debug mode for the development purposes on the website
  const displayDebug = ref<boolean>(false)

  const tickerClickHandler = (): void => {
    isTickerOpened.value = !isTickerOpened.value
    isMainMenuOpened.value = false
    isSearchOpened.value = false
  }

  const searchClickHandler = (): void => {
    isSearchOpened.value = !isSearchOpened.value
    isMainMenuOpened.value = false
    isTickerOpened.value = false
  }

  const mainMenuClickHandler = (): void => {
    isMainMenuOpened.value = !isMainMenuOpened.value
    isTickerOpened.value = false
    isSearchOpened.value = false
  }

  onStartTyping((event) => {
    inputBuffer.value += event.key
    if (inputBuffer.value.includes(debugValue)) {
      displayDebug.value = !displayDebug.value
      inputBuffer.value = ''
    }
    else if (inputBuffer.value.length > debugValue.length) {
      inputBuffer.value = inputBuffer.value.slice(-debugValue.length)
    }
  })

  return {
    isMainMenuOpened,
    isTickerOpened,
    isSearchOpened,
    displayDebug,

    tickerClickHandler,
    searchClickHandler,
    mainMenuClickHandler,
  }
})
